export const ru = {
    'all-audience': 'Вся аудитория',
    'day-description': {
        one: 'за {count} день',
        some: 'за {count} дня',
        many: 'за {count} дней',
        none: 'за {count} дней'
    },
    interests: 'Интересы',
    metrikaAudience: 'Яндекс.Аудитории и Яндекс.Метрика',
    'users-profiles': 'Профиль пользователя'
};
